import { Directive, Input, HostListener } from '@angular/core';
import { SelectDropdownComponent } from '../select-dropdown.component';

@Directive({
  selector: '[psUiSelectDropdownToggleFor]',
})
export class SelectDropdownDirective<T> {
  @Input('psUiSelectDropdownToggleFor') dropdown?: SelectDropdownComponent<T>;

  constructor() {}

  @HostListener('click')
  toggleDropdown() {
    this.dropdown?.toggle();
  }

  @HostListener('focus')
  onFocus() {
    console.log('focused');
  }
}
